export default {
	home: {
		afunOriginals: "AFun 오리지널",
		slots: "슬롯",
		liveCasino: "라이브 카지노",
		casualGames: "캐주얼 게임",
		newReleases: "신규 출시",
		casinoTitle: "카지노",
		casinoDesc: "수천 개의 슬롯, 라이브 딜러, 테이블 게임으로 카지노 게임을 즐기세요",
		goToCasino: "카지노로 이동",
		sportsTitle: "스포츠",
		sportsDesc: "축구, 농구, 테니스 등 최고의 배당률로 스포츠에 베팅하세요",
		goToSports: "스포츠로 이동",
		liveTitle: "라이브",
		liveDesc: "라이브 딜러와 인터랙티브 게임 경험으로 실시간 액션",
		goToLive: "라이브로 이동",
		latestBetRace: "최신 베팅 & 레이스",
		sports: "스포츠",
		latestBets: "최신 베팅",
		game: "게임",
		player: "플레이어",
		bet: "베팅",
		multiplier: "배수",
		profit: "수익",
		top10Games: "인기 게임 TOP 10",
		vip: "VIP",
		rewards: "보상",
		affiliate: "제휴 프로그램",
		promotion: "프로モーション"
	},

	latestBetRace: {
		title: "게임 리더보드 그랑프리",
		playerBetRank: "오늘의 플레이어 베팅",
		playerWinRank: "오늘의 플레이어 승리",
		gameBetRank: "오늘의 게임 베팅",
		gameWinRank: "오늘의 게임 환급",
		player: "플레이어",
		game: "게임",
		bet: "베팅",
		profit: "승리",
		ratio: "배당률",
		totalBet: "총 베팅액",
		totalReturn: "총 환급액",
		maxBet: "최대 베팅액",
		gameRatio: "환급률 %",
		noData: "데이터가 없습니다",
	},

	GameClassify: {
		casinoTitle: "카지노",
		casinoDesc: "최고의 제공업체가 선사하는 카지노 게임을 즐겨보세요",
		casinoBtn: "카지노로 이동",
		sportsTitle: "스포츠",
		sportsDesc: "축구, 크리켓, NFL, e스포츠 및 80여 개 이상의 스포츠에 베팅하세요",
		sportsBtn: "스포츠로 이동",
		liveTitle: "라이브",
		liveDesc: "라이브 딜러와 함께하는 실시간 리얼 액션",
		liveBtn: "라이브로 이동"
	}
}